import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusConexaoComponent } from 'src/app/refact/shared/components/teste-conexao/status-conexao/status-conexao.component';

@NgModule({
  declarations: [StatusConexaoComponent],
  imports: [
    CommonModule
  ],
  exports: [StatusConexaoComponent]
})
export class StatusConexaoModule { }
